<template>
  <div class="card">
    <b-table
      v-if="preventive == true"
      :items="items"
      :fields="computedFields"
      bordered
      responsive
      hover
    >
      <template #cell(link)="data">
        <a :href="data.item.link" target="_blank">
          <b-icon icon="link"></b-icon>
        </a>
      </template>
      <template #cell(status)="data">
        <span :class="getStatusClass(data.item.status)">
          {{ data.item.status }}
        </span>
      </template>
      <template #cell(kmFaltante)="data">
        <span
          :class="
            getKmFaltanteClass(data.item.kmFaltante, data.item.unidadeMedida)
          "
        >
          {{ data.item.kmFaltante }}
        </span>
      </template>
    </b-table>
    <b-table
      v-else-if="corrective == true"
      :items="items"
      :fields="computedFieldsCorrective"
      bordered
      responsive
      hover
    >
      <template #cell(link)="data">
        <a :href="data.item.link" target="_blank">
          <b-icon icon="link"></b-icon>
        </a>
      </template>
      <template #cell(status)="data">
        <span :class="getStatusClass(data.item.status)">
          {{ data.item.status }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "MaintenanceTable",
  props: {
    items: {
      type: Array,
      required: true
    },
    indiceValues: {
      type: Object,
      required: false
    },
    preventive: {
      type: Boolean,
      default: false
    },
    corrective: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: [
        { key: "link", label: "LINK" },
        { key: "placa", label: "PLACA" },
        { key: "marca", label: "MARCA" },
        { key: "modelo", label: "MODELO" },
        { key: "tipoRevisao", label: "TIPO" },
        { key: "intervalo", label: "INTERVALO" },
        { key: "ultimaTroca", label: "ULTIMA PREVENTIVA" },
        { key: "kmAtual", label: "MARCADOR ATUAL" },
        { key: "proximaTroca", label: "PROXIMA PREVENTIVA" },
        { key: "kmFaltante", label: "MARCADOR FALTANTE" },
        { key: "unidadeMedida", label: "MEDIDA" }
      ],
      fieldsCorrective: [
        { key: "link", label: "LINK" },
        { key: "entrada", label: "ENTRADA" },
        { key: "placa", label: "PLACA" },
        { key: "local", label: "LOCAL" },
        { key: "descricaoRevisao", label: "DESCRIÇÃO DO SERVIÇO" },
        { key: "km", label: "MARCADOR" },
        { key: "descricao", label: "DESCRIÇÃO" },
        { key: "fim", label: "SAÍDA" },
        { key: "valor", label: "VALOR" },
        { key: "status", label: "STATUS" },
        { key: "tempo", label: "DIAS EM MANUTENÇÃO" }
      ]
    };
  },
  computed: {
    computedFields() {
      return this.fields.map(field => {
        if (field.key === "link") {
          return {
            ...field,
            value: `${this.$apiChecklist}${field.value}`
          };
        }
        return field;
      });
    },
    computedFieldsCorrective() {
      return this.fieldsCorrective.map(field => {
        if (field.key === "link") {
          return {
            ...field,
            value: `${this.$apiChecklist}${field.value}`
          };
        }
        return field;
      });
    }
  },
  methods: {
    getStatusClass(status) {
      if (status === "EM MANUTENÇÃO") {
        return "km-red";
      } else if (status === "FINALIZADA") {
        return "km-green";
      } else if (status === "PROGRAMADA") {
        return "blue";
      }
      return "";
    },
    getKmFaltanteClass(kmFaltante, unidadeMedida) {
      let green, yellow, red;

      if (unidadeMedida === "Km") {
        ({ kmGreen: green, kmYellow: yellow, kmRed: red } = this.indiceValues);
      } else if (unidadeMedida === "Horas") {
        console.log("Horas"),
          ({
            horimeterGreen: green,
            horimeterYellow: yellow,
            horimeterRed: red
          } = this.indiceValues);
      } else if (unidadeMedida === "Dias") {
        ({
          daysGreen: green,
          daysYellow: yellow,
          daysRed: red
        } = this.indiceValues);
      }
      console.log(green, yellow, red);

      if (kmFaltante >= green) {
        return `km-green`;
      } else if (kmFaltante > red && kmFaltante < green) {
        return `km-yellow`;
      } else if (kmFaltante <= red) {
        return `km-red`;
      }
      return "";
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  max-width: 100%;
  padding: 20px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  align-items: center;
  border-color: #ffffff;
  border: 1px solid;
}

.danger {
  color: #ec5353;
  font-weight: 600;
}

.blue {
  color: #597aff;
  font-weight: 600;
}

.success {
  font-weight: 600;
  color: rgb(52, 160, 25);
}

.km-green {
  color: #28a745; /* Verde */
  font-weight: 600;
}

.km-yellow {
  color: #ffc107; /* Amarelo */
  font-weight: 600;
}

.km-red {
  color: #dc3545; /* Vermelho */
  font-weight: 600;
}
</style>
